// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__26pjR","errorLogs":"EditorFooter_errorLogs__1SdMn"};